import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotPersonalFinancesComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotPersonalFinances',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0076BE",
    fillRule: "evenodd",
    d: "M16.309 10.622H2v-1.85c0-1.08 1.305-1.95 2.922-1.95h8.445c1.616 0 2.922.87 2.922 1.95v1.85h.02Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6CC6FF",
    fillRule: "evenodd",
    d: "M14.273 2.232c.75-.48 1.74-.26 2.23.48l.03.04 3.9 6.19c.48.75.26 1.74-.47 2.23l-.04.03-10.42 6.55c-.75.48-1.74.26-2.23-.48l-.03-.04-3.9-6.19c-.48-.75-.26-1.74.48-2.23l.04-.03 10.42-6.55h-.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0076BE",
    d: "m16.813 3.212-13.19 8.29 1.43 2.27 13.18-8.29-1.43-2.27h.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0094EE",
    fillRule: "evenodd",
    d: "M2 9.912v9.51c0 1.44 1.205 2.6 2.691 2.6h16.307c.573 0 1.034-.45 1.034-1v-10.21c0-.55-.461-1-1.034-1L2 9.912Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0076BE",
    fillRule: "evenodd",
    d: "M22.009 13.01V18h-3.83s-1.87 0-1.87-2.5 1.87-2.5 1.87-2.5h3.83v.01Z"
  }));
};
SpotPersonalFinancesComponent.displayName = 'SpotPersonalFinances';
export var SpotPersonalFinances = withProvisionalOverrideFromContext(SpotPersonalFinancesComponent);
//# sourceMappingURL=index.js.map